<script lang="ts">
	import type { WithElementRef } from 'bits-ui'
	import type { HTMLAttributes } from 'svelte/elements'
	import { cn } from 'tailwind-variants'

	let {
		ref = $bindable(null),
		class: className,
		children,
		...restProps
	}: WithElementRef<HTMLAttributes<HTMLUListElement>, HTMLUListElement> = $props()
</script>

<ul
	bind:this={ref}
	class={cn('flex w-full min-w-0 flex-col gap-0', className)}
	data-sidebar="menu"
	data-slot="sidebar-menu"
	{...restProps}
>
	{@render children?.()}
</ul>
